export default function Header({ title, total, actionButton }) {
    return (
        <header className="flex h-16 shrink-0 items-center justify-between border-b border-gray-200 bg-white px-6 dark:bg-surface-dark dark:border-gray-800 transition-colors">
            <div className="flex items-center gap-4">
                <h2 className="text-lg font-bold text-text-main dark:text-white">{title}</h2>
                {total !== undefined && (
                    <div className="flex items-center gap-2">
                        <div className="h-4 w-px bg-gray-200 dark:bg-gray-700"></div>
                        <div className="text-sm text-text-secondary">Total: {total}</div>
                    </div>
                )}
            </div>
            <div className="flex items-center gap-4">
                {actionButton}
            </div>
        </header>
    );
}
